"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme["default"];
  }
});

exports["default"] = void 0;

var _Form = _interopRequireDefault(require("./components/Form"));

var _withTheme = _interopRequireDefault(require("./withTheme"));

var _default = _Form["default"];
exports["default"] = _default;